// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-dropdown-triangle[data-v-1c9e23f9]{transition:all .2s;transform-origin:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
